export default "__VITE_ASSET__ue827uMI__"